/*
  Our MDX only has access to `AssignableChildren.server`, a Server Component. Ideally, that component would lazy-load `AssignableChildren` directly, but next/dynamic only works properly in a Client Component. So, this component acts as a bridge, being importable by a Server Component and handling the lazy-loading.
*/

'use client';

import dynamic from 'next/dynamic';

const AssignableChildren = dynamic(
  () => import('./AssignableChildren')
);

export default AssignableChildren;
